import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useProvider'

import { ProviderModel } from '@models/types'

interface ProviderListItemProps {
  provider: Partial<ProviderModel>,
}

const ProviderListItem = (props: ProviderListItemProps) => {
  const {
    provider,
    provider: {
      email,
      id,
      phone,
      title,
    },
  } = props

  const { editProviderRelationsUrl } = generateUrls(provider)

  return (
    <DashboardModuleListItem
      href={editProviderRelationsUrl}
      secondaryText={email}
      title={<Box>{title}&nbsp;<Text color="bodyFontLightColor">#{id}</Text></Box>}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {phone}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default ProviderListItem
